import React from 'react'
import {
  AicpaMattersIcon,
  AntiMoneyLaunderingIcon,
  ArtificialIntelligenceIcon,
  AutomationIcon,
  AvatarMaleIcon,
  BlockchainIcon,
  BlockchainInterestsIcon,
  BusinessCombinationsIcon,
  CECLIcon,
  CertificateIcon,
  ChainLinkIcon,
  ChartIcon,
  ChartLineIcon,
  Covid19Icon,
  CryptocurrencyIcon,
  CryptocurrencyInterestsIcon,
  CustomerExperienceIcon,
  CyberSecurityInterestsIcon,
  DataAnalyticsIcon,
  DebtAndEquityIcon,
  DecisionIcon,
  DerivativesAndHedgingIcon,
  DigitalAssetsIcon,
  DigitalEvolutionIcon,
  DistressedRealEstateIcon,
  DollarPieChartIcon,
  EarthIcon,
  EconomicsIcon,
  ElectionIcon,
  EmployeeBenefitPlansIcon,
  EmployeeBenefitsIcon,
  EsgIcon,
  FederalSealIcon,
  FinancialAssetsIcon,
  FinancialReportingIcon,
  GoingPublicIcon,
  HandCurrencyIcon,
  HandPeopleIcon,
  HeadquartersBuildingIcon,
  HousePercentIcon,
  IdeationIcon,
  IncomeTaxesIcon,
  InflationIcon,
  InnovationIcon,
  IntangiblesAndOtherAssetsIcon,
  InternationalStandardsIcon,
  LaborAndWorkforceIcon,
  LeaseAccountingIcon,
  MagnifyingGlassDollarsIcon,
  MagnifyingGlassIcon,
  MaskFemaleIcon,
  MicrochipIcon,
  MMBIIcon,
  MobileLockIcon,
  NewsIcon,
  OpportunityZonesIcon,
  OtherAccountingTopicsIcon,
  PcaobMattersIcon,
  PolicyIcon,
  PostItsIcon,
  PresentationIcon,
  RevenueRecognitionIcon,
  RobotHandMobileIcon,
  RocketIcon,
  RsmClassicIcon,
  SECMattersIcon,
  SPACIcon,
  StateAndTaxNexusIcon,
  StewardshipIcon,
  SupplyChainIcon,
  SustainabilityIcon,
  TeamworkIcon,
  TheRealEconomyIcon,
  TitleDeedIcon,
  VisionDentalMedicalIcon,
  VotePinIcon,
} from '@rsmus/myrsm-icons'
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag'
import { TagIconMap } from '../types'

const TopicsIconMapper = () => {
  const userRedesignFeatureEnabled = useFeatureFlag('UserProfile_Redesign')
  const tagIconMap: TagIconMap = userRedesignFeatureEnabled
    ? {
        // this list is incomplete and will be updated in a later story
        'aicpa-matters': <AicpaMattersIcon />,
        'anti-money-laundering': <AntiMoneyLaunderingIcon />,
        'artificial-intelligence': <ArtificialIntelligenceIcon />,
        automation: <AutomationIcon />,
        blockchain: <BlockchainInterestsIcon />,
        'business-combinations': <BusinessCombinationsIcon />,
        cecl: <CECLIcon />,
        'covid-19': <Covid19Icon />,
        cryptocurrency: <CryptocurrencyInterestsIcon />,
        'customer-experience': <CustomerExperienceIcon />,
        cybersecurity: <CyberSecurityInterestsIcon />,
        'data-analytics': <DataAnalyticsIcon />,
        'debt-equity': <DebtAndEquityIcon />,
        '-derivatives-and-hedging': <DerivativesAndHedgingIcon />,
        'digital-assets': <DigitalAssetsIcon />,
        'digital-evolution': <DigitalEvolutionIcon />,
        'distressed-real-estate': <DistressedRealEstateIcon />,
        economics: <EconomicsIcon />,
        election: <ElectionIcon />,
        'employee-benefit-plans': <EmployeeBenefitPlansIcon />,
        'employee-benefits': <EmployeeBenefitsIcon />,
        esg: <EsgIcon />,
        'financial-assets': <FinancialAssetsIcon />,
        'financial-reporting': <FinancialReportingIcon />,
        'going-public': <GoingPublicIcon />,
        'income-taxes': <IncomeTaxesIcon />,
        inflation: <InflationIcon />,
        innovation: <InnovationIcon />,
        'intangibles-and-other-assets': <IntangiblesAndOtherAssetsIcon />,
        'international-standards': <InternationalStandardsIcon />,
        'labor-and-workforce': <LaborAndWorkforceIcon />,
        'lease-accounting': <LeaseAccountingIcon />,
        mmbi: <MMBIIcon />,
        'opportunity-zones': <OpportunityZonesIcon />,
        'other-accounting-topics': <OtherAccountingTopicsIcon />,
        'pcaob-matters': <PcaobMattersIcon />,
        policy: <PolicyIcon />,
        'revenue-recognition': <RevenueRecognitionIcon />,
        'rsm-classic': <RsmClassicIcon />,
        'sec-matters': <SECMattersIcon />,
        spac: <SPACIcon />,
        'state-tax-nexus': <StateAndTaxNexusIcon />,
        stewardship: <StewardshipIcon />,
        'supply-chain': <SupplyChainIcon />,
        sustainability: <SustainabilityIcon />,
        'the-real-economy': <TheRealEconomyIcon />,
      }
    : {
        'aicpa-matters': <AvatarMaleIcon />,
        'anti-money-laundering': <HandCurrencyIcon />,
        blockchain: <BlockchainIcon />,
        cecl: <MagnifyingGlassDollarsIcon />,
        'covid-19': <MaskFemaleIcon />,
        cryptocurrency: <CryptocurrencyIcon />,
        cybersecurity: <MobileLockIcon />,
        'digital-assets': <MicrochipIcon />,
        'digital-evolution': <RobotHandMobileIcon />,
        'distressed-real-estate': <HousePercentIcon />,
        economics: <DollarPieChartIcon />,
        election: <VotePinIcon />,
        'employee-benefit-plans': <HandPeopleIcon />,
        'employee-benefits': <VisionDentalMedicalIcon />,
        esg: <DecisionIcon />,
        'financial-reporting': <PresentationIcon />,
        'going-public': <RocketIcon />,
        inflation: <ChartLineIcon />,
        innovation: <IdeationIcon />,
        'international-standards': <EarthIcon />,
        'labor-and-workforce': <TeamworkIcon />,
        'lease-accounting': <TitleDeedIcon />,
        'opportunity-zones': <MagnifyingGlassIcon />,
        'pcaob-matters': <PostItsIcon />,
        policy: <CertificateIcon />,
        'revenue-recognition': <ChartIcon />,
        'sec-matters': <FederalSealIcon />,
        spac: <HeadquartersBuildingIcon />,
        'state-tax-nexus': <NewsIcon />,
        'supply-chain': <ChainLinkIcon />,
      }

  return tagIconMap
}

export default TopicsIconMapper
